import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import zhCN from './locales/zh-CN.json'
import fr from './locales/fr.json'
import de from './locales/de.json'

export type SupportedLanguage = 'en' | 'zh-CN' | 'fr' | 'de'

export const supportedLanguages: { code: SupportedLanguage; name: string; flag: string }[] = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'zh-CN', name: '中文', flag: '🇨🇳' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
]

// 从 localStorage 获取保存的语言设置
const getSavedLanguage = (): SupportedLanguage => {
  const saved = localStorage.getItem('preferred-language')
  if (saved && supportedLanguages.some(lang => lang.code === saved)) {
    return saved as SupportedLanguage
  }
  return 'en'
}

// 检测浏览器语言
export const detectBrowserLanguage = (): SupportedLanguage => {
  const browserLang = navigator.language.toLowerCase()
  
  if (browserLang.startsWith('zh')) return 'zh-CN'
  if (browserLang.startsWith('fr')) return 'fr'
  if (browserLang.startsWith('de')) return 'de'
  return 'en'
}

// 初始化语言
const initialLocale = getSavedLanguage() || detectBrowserLanguage()

const i18n = createI18n({
  legacy: false,
  locale: initialLocale,
  fallbackLocale: 'en',
  messages: {
    en,
    'zh-CN': zhCN,
    fr,
    de,
  },
})

export default i18n

// 切换语言函数
export const setLanguage = (lang: SupportedLanguage) => {
  i18n.global.locale.value = lang
  localStorage.setItem('preferred-language', lang)
  document.querySelector('html')?.setAttribute('lang', lang)
  
  // 更新 URL 参数
  const url = new URL(window.location.href)
  url.searchParams.set('lang', lang)
  window.history.replaceState({}, '', url.toString())
}
